<template lang="slm">
  div
    .section.header
      .container
        p Церковь имеет помазанную команду Worship Band, которая создает помазанные песни, касающиеся сердца людей. В нашей звукозаписывающей студии команда записывает альбомы с авторскими песнями и кавер-версиями известных христианских исполнителей. Мы выпускаем специальные СД-диски для домашних групп, чтобы поклоняться в домашней обстановке.
        p Бог любит, когда Его хвалят. А еще больше любит громкую и искреннюю хвалу, наполненную благодарностью. Наша молодежная музыкальная группа 4UBand регулярно выпускает альбомы с собственными песнями, через которые Дух Святой касается сердец не только в Мелитополе, но и в других городах и странах.
    template v-for='album in albums'
      music-album-section :album='album' ref='albumSections'
</template>

<style lang='stylus' scoped>
.section
  color white
  &.header
    font-size 24px
    font-weight 500
    text-align left
    background-color dark-color
</style>

<script>
import gql from 'graphql-tag';
import MusicAlbumSection from '@/components/MusicAlbumSection';

export default {
  name: 'MusicPage',
  components: { MusicAlbumSection },
  data() {
    return {
      albums: [],
    };
  },
  apollo: {
    albums: {
      query: gql`{ albums { coverId title artist year hash songs { title duration fileId } serviceLinks { service link } } }`,
    },
  },
  watch: {
    albums() {
      this.$_scrollToAnchor();
    },
  },
};
</script>
